import React from 'react';

//Components
import {IconedButton} from 'components/IconedButton';
import {useNavigate} from 'components/lib';

//Helpers
import {UnlimitedCard} from 'components/unlimitedCard/card';

export function Declined({reason}) {
  const navigate = useNavigate();

  return (
    <div>
      <div className="w-full flex items-center justify-between">
        <IconedButton
          size="130px"
          color="#d32425"
          textColor="white"
          icon="arrow-left"
          text="Go back"
          action={() => {
            navigate('/app/quote/app');
          }}
        />
      </div>
      <UnlimitedCard className="mb-14 w-1/2 mx-auto" id="14">
        <div className="text-center">
          Your quote was <strong>DECLINED.</strong>
        </div>
        <div style={{marginTop: 20}}>
          <p className="font-semibold mb-2">Reason(s):</p>

          {Array.isArray(reason) ? (
            reason.every(r => typeof r === 'string' && r.length === 1) ? (
              <p className="mb-1">
                - {reason.join('')}
              </p>
            ) : (
              reason
                .filter(r => typeof r === 'string' && r.trim() !== '')
                .map((r, i) => {
                  let message = r.trim();

                  if (
                    message ===
                    `3 Losses must be confirmed at least for the prior 3 policy years. Click "Change Application" and see "Losses" tab.`
                  ) {
                    message =
                      '3 Losses must be confirmed at least for the prior 3 policy years. Click edit your quote and make sure you have added the last 3 years of losses.';
                  }

                  return (
                    <p key={i} className="mb-1">- {message}</p>
                  );
                })
            )
          ) : (
            <p className="mb-1">
              - {reason}
            </p>
          )}
        </div>
      </UnlimitedCard>
    </div>
  );
}

export default Declined;
